import React, { useCallback, useEffect, useState } from "react";
import { axiosInstance } from "../../api/axiosDefaults";
import { Button, Card, Col, Row, Modal } from "react-bootstrap";
import btnStyles from "../../styles/Button.module.css";
import useActivePlan from "../../hooks/useActivePlan";
import { useHistory, useLocation } from "react-router-dom";
// import { Chip } from "@mantine/core";
import GreenTick from "../../assets/green-tick.png";
import { toast } from "react-hot-toast";
import styles from "../../styles/Account.module.css";
import InfoSub from "./InfoSub";
import SubChart from "./SubChart";

const MAX_USERS_MESSAGE =
  "Please contact the administrator. The plan has reached its maximum user limit.";

const MaxUsersNotice = () => (
  <p
    className={`${styles.btnSubscriptionPage}`}
    style={{ color: "orange", fontWeight: "bold", fontSize: "13px" }}
  >
    {MAX_USERS_MESSAGE}
  </p>
);

export default function SubscriptionPlansPage() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shouldDelayPaymentSync = searchParams.get("payment_sync") === "pending";
  const [showImp, setShowImp] = useState(false);
  const [showCha, setShowCha] = useState(false);
  const [isPaymentSyncing, setIsPaymentSyncing] = useState(shouldDelayPaymentSync);
  const {
    loading: currentlyActivePlanLoading,
    currentlyActivePlans,
    fetchMyActivePlan,
  } = useActivePlan({ skipInitialFetch: shouldDelayPaymentSync });


  const [allCompanyPlans, setAllCompanyPlans] = useState([]);
  const [allStudPlans, setAllStudPlans] = useState([]);
  const [allBudgetPlans, setAllBudgetPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [show, setShow] = useState(false);
  const [type, setType] = useState('project')
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const isPageLoading = loading || currentlyActivePlanLoading || isPaymentSyncing;
  const handleClose = () => {
    setShow(false);
    setSelectedPlanId(null);
  };
  const handleCloseDelete = () => {
    handleCancelSubscription();
    setShow(false);
  };
  const handleShow = (type, planId) => {
    setShow(true);
    setType(type);
    setSelectedPlanId(planId);
  }

  const choosePlan = async (plan) => {
    // console.log(plan);
    // return;
    if (plan?.plan_type === "budget") {
      history.push(`/payment/budget/${plan?.id}`);
    } else {
      const encodedPlanName = encodeURIComponent(plan?.name);
      history.push(
        `/payment/${encodedPlanName}/${plan?.id}/${plan?.subscription_category?.id}`
      );
    }
  };

  // const findStartedDate = (plan) => {
  //   if (!currentlyActivePlans || currentlyActivePlans?.length <= 0) {
  //     return null;
  //   }
  //   const subPlan = currentlyActivePlans?.find(
  //     (activePlan) => activePlan?.plan?.id === plan?.id
  //   );
  //   if (!subPlan) {
  //     return null;
  //   }
  //   return subPlan?.current_period_start;
  // };

  const findDates = (plan) => {
    if (!currentlyActivePlans || currentlyActivePlans?.length <= 0) {
      return null;
    }
    const subPlan = currentlyActivePlans?.find(
      (activePlan) => activePlan?.plan?.id === plan?.id
    );
    if (!subPlan) {
      return null;
    }
    // console.log("isTrail", subPlan);
    if (subPlan?.plan?.plan_type === "project") {
      if (subPlan?.inTrial) {
        return {
          startDate: subPlan?.created_at,
          trialEndDate: subPlan?.current_period_end,
        };
      } else {
        return {
          startDate: subPlan?.current_period_start,
          renewalDate: subPlan?.current_period_end,
        };
      }
    } else {
      if (subPlan?.inTrial) {
        return {
          startDate: subPlan?.created_at,
          trialEndDate: subPlan?.current_period_end,
        };
      } else {
        return {
          startDate: subPlan?.current_period_start,
          renewalDate: subPlan?.current_period_end,
        };
      }
    }
  };

  const handleCancelSubscription = async () => {
    const selectedActivePlan = currentlyActivePlans?.find(
      (activePlan) => activePlan?.plan?.id === selectedPlanId
    );

    if (!selectedActivePlan) {
      return toast.error("No plan is active yet!");
    }

    if (!selectedActivePlan?.stripe_subscription_id) {
      return toast.error("No Stripe subscription found for this plan.");
    }

    try {
      setIsCancelling(true);
      const response = await axiosInstance.post(
        `/cancel-subscription/`,
        {
          stripe_subscription_id: selectedActivePlan?.stripe_subscription_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      if (response?.data?.status === 200) {
        setIsCancelling(false);
        fetchData();
        fetchMyActivePlan();
      }
    } catch (err) {
      setIsCancelling(false);
      console.log(err);
    }
  };

  const enabledBuy = (plan, planType = plan?.plan_type) => {
    if (currentlyActivePlans?.length <= 0) return true;

    const currentActivePlan = currentlyActivePlans?.find(
      (p) =>
        p?.plan?.plan_type === planType &&
        p?.is_active !== false &&
        p?.auto_renewal !== false
    );

    if (!currentActivePlan) return true;

    if (
      currentActivePlan?.plan?.subscription_category?.name ===
      "Company" &&
      plan?.subscription_category?.name === "Student"
    ) {
      return false;
    }
    if (
      currentActivePlan?.plan?.subscription_category?.name ===
      "Student" &&
      plan?.subscription_category?.name === "Company"
    ) {
      return true;
    }
    if (Number(currentActivePlan?.plan?.price) > Number(plan?.price)) {
      return false;
    }
    return true;
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/plans/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        withCredentials: true,
      });

      if (response?.data?.status === 200) {
        // console.log(response?.data?.data);
        setLoading(false);
        const projectCatergories = response?.data?.data?.filter(
          (p) => p?.category?.name !== "Budget Only"
        );

        const companyCategory = projectCatergories?.find(
          (p) => p.category.name === "Company"
        );
        const companyPlans = companyCategory?.plans;
        // console.log("company plans", companyPlans);
        setAllCompanyPlans(companyPlans);
        const studCategory = projectCatergories?.find(
          (p) => p.category.name === "Student"
        );
        const studPlans = studCategory?.plans;
        // console.log("stud plans", studPlans);
        setAllStudPlans(studPlans);

        const budgetCatergory = response?.data?.data?.filter(
          (p) => p?.category?.name === "Budget Only"
        );
        const budgetPlans = budgetCatergory[0]?.plans;
        // console.log("budget plans", budgetPlans);
        // setAllProjectPlans(projectPlans);
        setAllBudgetPlans(budgetPlans);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  useEffect(() => {
    if (!shouldDelayPaymentSync) {
      fetchData();
    }
  }, [fetchData, shouldDelayPaymentSync]);

  useEffect(() => {
    if (!shouldDelayPaymentSync) {
      return;
    }

    const syncTimer = setTimeout(async () => {
      await fetchMyActivePlan();
      await fetchData();
      setIsPaymentSyncing(false);
      history.replace("/subscription-plans");
    }, 6000);

    return () => clearTimeout(syncTimer);
  }, [fetchData, fetchMyActivePlan, history, shouldDelayPaymentSync]);

  // console.log(allCompanyPlans);
  // console.log(allStudPlans);

  return (
    <div className="pb-2 px-3">
      <h3
        className="text-center py-4 w-100 mt-2"
        style={{
          // background: "#3B444A",
          background: "#39606e",
          color: "#F5F5F5",
          // fontFamily: "Playfair Display",
          textTransform: "uppercase",
        }}
      >
        Subscription Plans
      </h3>
      {isPaymentSyncing && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(5, 15, 47, 0.55)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          }}
        >
          <div
            className="text-center"
            style={{
              background: "#ffffff",
              borderRadius: "6px",
              boxShadow: "0 12px 32px rgba(0, 0, 0, 0.22)",
              color: "#39606e",
              fontWeight: "bold",
              maxWidth: "420px",
              padding: "1.5rem",
              width: "100%",
            }}
          >
            Confirming your payment and updating your subscription...
          </div>
        </div>
      )}
      {/* back chart info */}
      <Row className="mt-1">
        <Col xs={4} className="">
        <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
        </Button>
        </Col>
        <Col xs={4} className="text-center">
        <Button
          className={`px-3 px-md-5 ${btnStyles.Button} ${btnStyles.Shed}`}
          onClick={() => setShowCha(showCha => !showCha)}
        >CHART
        </Button>
        </Col>
        <Col xs={4} >
        <Button
          className={`float-right px-3 ${btnStyles.Button} ${btnStyles.Order}`}
          onClick={() => setShowImp(showImp => !showImp)}
        >INFO
        </Button>
        </Col>
      </Row>
      {!showImp ? (
          ""
              ) : (
                <InfoSub  /> 
      ) } 
      {!showCha ? (
          ""
              ) : (
                <SubChart  /> 
      ) } 
      <Row className="my-2">
      <Col md={{span: 8, offset: 2}} className={`text-center`} >
        <p className={`${styles.SmallSize}`}>
      Please click the Info and Chart buttons for Subscription information
      </p>
      </Col>
      </Row>
      <div>
        <Row style={{gap: "2rem",}}>
          {/* PLATFORM PLANS */}
          <Col xs={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              {/* Company Platform Projects with Budget Plans */}
              <div style={{ marginBottom: "2rem" }}>
              <Row >
              <Col className="text-center">
              <h5 className={`mt-1 py-1 text-center ${styles.SubTitle4}`}
              >PLATFORM PROJECTS WITH BUDGET PLANS
              </h5>
              </Col>
              </Row>
                <h3
                  className="px-2 mt-3 text-center"
                  style={{
                    fontWeight: "bold",
                    color: "#000"
                  }}
                >
                  ENTERPRISE 
                </h3>
                <p className={` ${styles.SmallSize} text-center`}>(For all large professional projects - Maximum Users)</p>
                <Row className="justify-content-center">
                  {!isPageLoading &&
                    allCompanyPlans?.map((plan) => (
                      <Col key={plan?.id} xs={12} md={3}>
                        <Card className={`${styles.btnSubscription}`}
                          style={{
                            // padding: "2rem",
                            // height: "370px",
                            marginBottom: "1rem",
                            border: `${currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            )
                              ? "1px solid green"
                              : ""
                              }`,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <h4 style={{ fontWeight: "bold" }}>
                                {plan?.name}
                              </h4>
                              {currentlyActivePlans?.find(
                                (p) => p?.plan?.id === plan?.id
                              ) && (
                                  <div
                                    style={{
                                      fontWeight: "bold",
                                      color: "#ffffff",
                                      background: "#2bb673",
                                      borderRadius: "20px",
                                      height: "26px",
                                      width: "75px",
                                      fontSize: "14px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                            </div>
                            {plan?.description && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "0.5rem",
                                }}
                              >
                                <img src={GreenTick} height={20} width={20} alt="check" />

                                <p>{plan?.description}</p>
                              </div>
                            )}
                            <p className="mb-0">
                              <span style={{ fontWeight: "bold" }}>Price</span>:
                              ${plan?.price}
                            </p>
                            {findDates(plan)?.startDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Start Date
                                </span>
                                : {findDates(plan)?.startDate}
                              </p>
                            )}
                            {findDates(plan)?.renewalDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Renewal Date
                                </span>
                                : {findDates(plan)?.renewalDate}
                              </p>
                            )}
                            {findDates(plan)?.trialEndDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Trial End Date
                                </span>
                                : {findDates(plan)?.trialEndDate}
                              </p>
                            )}
                            {plan?.plan_type !== "budget" && (
                              <p
                                className="mb-0"
                                style={{ fontWeight: "bold" }}
                              >
                                Max project with budget: {plan?.max_projects}
                              </p>
                            )}
                            {plan?.interval && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Interval
                                </span>
                                : {plan?.interval}
                              </p>
                            )}

                            {/* {!currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            ) ? (
                              <>
                                {!currentlyActivePlans?.find(
                                  (p) => p?.plan?.plan_type === "project"
                                ) ? (
                                  <Button
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      choosePlan(plan);
                                    }}
                                  >
                                    Buy
                                  </Button>
                                ) : (
                                  <Button
                                    className="card-absolute-btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if (enabledBuy(plan)) {
                                        choosePlan(plan);
                                      }
                                    }}
                                    disabled={!enabledBuy(plan)}
                                  >
                                    {enabledBuy(plan)
                                      ? "Upgrade"
                                      : "Unavailable"}
                                  </Button>
                                )}
                              </>
                            ) : (
                              <Button
                                className="card-absolute-btn"
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "red",
                                }}
                                onClick={handleShow}
                                disabled={isCancelling}
                              >
                                Cancel Subscription
                              </Button>
                            )} */}

                            {(() => {
                              const activePlan = currentlyActivePlans?.find(
                                (p) => p?.plan?.id === plan?.id
                              );
                              // 1. Show message if plan is cancelled but still usable
                              if (activePlan?.auto_renewal === false) {
                                return (
                                  <p className={`${styles.btnSubscriptionPage}`} style={{ color: "orange", fontWeight: "bold", fontSize: '13px' }}>
                                    Your subscription is cancelled, but you can use the service until{" "}
                                    {activePlan?.current_period_end}
                                  </p>
                                );
                              }

                              // 2. Show Cancel button if plan is inactive (edge case)
                              if (activePlan?.is_active === false) {
                                return (
                                  <Button
                                    className={`${styles.btnSubscriptionPage}`}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: "red",
                                    }}
                                    onClick={() => handleShow('projects', plan?.id)}
                                    disabled={isCancelling}
                                  >
                                    Cancel Subscription
                                  </Button>
                                );
                              }

                              // 3. If no active plan, show Buy/Upgrade logic
                              if (!activePlan) {
                                if (plan?.can_add_subscription === false) {
                                  return <MaxUsersNotice />;
                                }

                                const hasProjectPlan = currentlyActivePlans?.find(
                                  (p) => p?.plan?.plan_type === "project"
                                );

                                return !hasProjectPlan ? (
                                  <Button
className={`${styles.btnSubscriptionPage}`}          
                          style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      choosePlan(plan);
                                    }}
                                  >
                                    Buy
                                  </Button>
                                ) : (
                                  <Button
className={`${styles.btnSubscriptionPage}`}           
                         style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if (enabledBuy(plan)) {
                                        choosePlan(plan);
                                      }
                                    }}
                                    disabled={!enabledBuy(plan)}
                                  >
                                    {enabledBuy(plan) ? "Upgrade" : "Unavailable"}
                                  </Button>
                                );
                              }

                              // 4. Default case: show Cancel button
                              return (
                                <Button
className={`${styles.btnSubscriptionPage}`}             
                     style={{
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                  }}
                                  onClick={() => handleShow('projects', plan?.id)}
                                  disabled={isCancelling}
                                >
                                  Cancel Subscription
                                </Button>
                              );
                            })()}

                            <Modal show={show} onHide={handleClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  Confirm Cancel Subscription
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                Are you sure you want to cancel your
                                subscription? Once canceled, you will no longer
                                have access to your {type} after the current payment period is up.
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={handleClose}
                                >
                                  NO
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={handleCloseDelete}
                                >
                                  YES
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </div>
              {/* Indie/Student Platform Projects with Budget Plans */}
              <div style={{ marginBottom: "2rem" }}>
                <h3
                  className="px-2 pt-4 text-center"
                  style={{
                    fontWeight: "bold",
                    color: "#000"
                  }}
                >
                  STANDARD
                </h3>
                <p className={` ${styles.SmallSize} text-center`}>(For smaller Indie or Student projects - Limited Users)</p>
                <Row className="justify-content-center">
                  {!loading &&
                    allStudPlans?.map((plan) => (
                      <Col key={plan?.id} xs={12} md={3}>
                        <Card className={`${styles.btnSubscription}`}
                          style={{
                            // padding: "2rem",
                            // height: "370px",
                            marginBottom: "1rem",
                            border: `${currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            )
                              ? "1px solid green"
                              : ""
                              }`,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            {/* {plan?.plan_type === "budget" && (
                        <h4>Pay for Budget</h4>
                      )} */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <h4 style={{ fontWeight: "bold" }}>
                                {plan?.name}
                              </h4>
                              {currentlyActivePlans?.find(
                                (p) => p?.plan?.id === plan?.id
                              ) && (
                                  <div
                                    style={{
                                      fontWeight: "bold",
                                      color: "#ffffff",
                                      background: "#2bb673",
                                      borderRadius: "20px",
                                      height: "26px",
                                      width: "75px",
                                      fontSize: "14px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      // borderRadius: "20px",
                                      // border: "1px solid green",
                                      // padding: "0.3rem 0.8rem",
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                            </div>
                            {plan?.description && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "0.5rem",
                                }}
                              >
                                <img src={GreenTick} height={20} width={20} alt="check" />

                                <p>{plan?.description}</p>
                              </div>
                            )}
                            <p className="mb-0">
                              <span style={{ fontWeight: "bold" }}>Price</span>:
                              ${plan?.price}
                            </p>

                            {findDates(plan)?.startDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Start Date
                                </span>
                                : {findDates(plan)?.startDate}
                              </p>
                            )}
                            {findDates(plan)?.renewalDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Renewal Date
                                </span>
                                : {findDates(plan)?.renewalDate}
                              </p>
                            )}
                            {findDates(plan)?.trialEndDate && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Trial End Date
                                </span>
                                : {findDates(plan)?.trialEndDate}
                              </p>
                            )}

                            {/* <p>Plan Id: {plan?.stripe_plan_id}</p> */}
                            {plan?.plan_type !== "budget" && (
                              <p
                                className="mb-0"
                                style={{ fontWeight: "bold" }}
                              >
                                Max project with budget: {plan?.max_projects}
                              </p>
                            )}
                            {plan?.interval && (
                              <p className="mb-0">
                                <span style={{ fontWeight: "bold" }}>
                                  Interval
                                </span>
                                : {plan?.interval}
                              </p>
                            )}

                            {/* {!currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            ) ? (
                              <>
                                {!currentlyActivePlans?.find(
                                  (p) => p?.plan?.plan_type === "project"
                                ) ? (
                                  <Button
                                    className="card-absolute-btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      choosePlan(plan);
                                    }}
                                  >
                                    Buy
                                  </Button>
                                ) : (
                                  <Button
                                    className="card-absolute-btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if (enabledBuy(plan)) {
                                        choosePlan(plan);
                                      }
                                    }}
                                    disabled={!enabledBuy(plan)}
                                  >
                                    {enabledBuy(plan)
                                      ? "Upgrade"
                                      : "Unavailable"}
                                  </Button>
                                )}
                              </>
                            ) : (
                              <Button
                                className="card-absolute-btn"
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "red",
                                }}
                                onClick={handleShow}
                                disabled={isCancelling}
                              >
                                Cancel Subscription
                              </Button>
                            )} */}

                            {(() => {
                              const activePlan = currentlyActivePlans?.find(
                                (p) => p?.plan?.id === plan?.id
                              );
                              //  1. Show cancellation message if auto_renewal is false
                              if (activePlan?.auto_renewal === true) {
                                return (
                                  <Button
className={`${styles.btnSubscriptionPage}`}                             
       style={{
                                      cursor: "pointer",
                                      backgroundColor: "red",
                                    }}
                                    onClick={() => handleShow('projects', plan?.id)}
                                    disabled={isCancelling}
                                  >
                                    Cancel Subscription
                                  </Button>
                                );
                              }

                              // 2. Show cancel button if plan is inactive
                              if (activePlan?.auto_renewal === false) {
                                return (
                                  <p className={`${styles.btnSubscriptionPage}`} style={{ color: "orange", fontWeight: "bold", fontSize: '13px' }}>
                                    Your subscription is cancelled but you can use the service until{" "}
                                    {activePlan?.current_period_end}
                                  </p>
                                );
                              }

                              //  3. No active plan — Buy / Upgrade / Unavailable flow
                              if (!activePlan) {
                                if (plan?.can_add_subscription === false) {
                                  return <MaxUsersNotice />;
                                }

                                const hasProjectPlan = currentlyActivePlans?.find(
                                  (p) => p?.plan?.plan_type === "project"
                                );

                                return !hasProjectPlan ? (
                                  <Button
className={`${styles.btnSubscriptionPage}`}       
                             style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      choosePlan(plan);
                                    }}
                                  >
                                    Buy
                                  </Button>
                                ) : (
                                  <Button
className={`${styles.btnSubscriptionPage}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if (enabledBuy(plan)) {
                                        choosePlan(plan);
                                      }
                                    }}
                                    disabled={!enabledBuy(plan)}
                                  >
                                    {enabledBuy(plan) ? "Upgrade" : "Unavailable"}
                                  </Button>
                                );
                              }

                              //  4. Default active plan — Show cancel button
                              return (
                                <Button
className={`${styles.btnSubscriptionPage}`}           
                       style={{
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                  }}
                                  onClick={() => handleShow('projects', plan?.id)}
                                  disabled={isCancelling}
                                >
                                  Cancel Subscription
                                </Button>
                              );
                            })()}

                          </div>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </div>
              </div>
              </Col>
          {/* BUDGET PLANS */}
          <Col xs={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              {/* <h3
                className="px-2 pb-4 text-center"
                style={{
                  fontWeight: "bold",
                }}
              >
                Budget Only Subscription Plans
              </h3> */}
              <Row >
              <Col className="text-center">
              <h3 className={`mt-1 py-1 text-center ${styles.SubTitle4}`}
              >BUDGET ONLY SUBSCRIPTION PLANS
              </h3>
              </Col>
              </Row>
              <Row className="justify-content-center">
                {!isPageLoading &&
                  allBudgetPlans?.map((plan) => (
                    <Col key={plan?.id} xs={12} md={3} className="mt-3">
                      <Card className={`${styles.btnSubscription}`}
                        style={{
                          // padding: "2rem",
                          // height: "370px",
                          border: `${currentlyActivePlans?.find(
                            (p) => p?.plan?.id === plan?.id
                          )
                            ? "1px solid green"
                            : ""
                            }`,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {/* {plan?.plan_type === "budget" && (
                          <h4>Pay for Budget</h4>
                        )} */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <h4 style={{ fontWeight: "bold" }}>{plan?.name}</h4>
                            {currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            ) && (
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    color: "#ffffff",
                                    background: "#2bb673",
                                    borderRadius: "20px",
                                    height: "26px",
                                    width: "75px",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Active
                                </div>
                              )}
                          </div>
                          {plan?.description && <div
                            style={{
                              display: "flex",
                              gap: "0.5rem",
                            }}
                          >
                            <img src={GreenTick} height={20} width={20} alt="check" />

                            <p>{plan?.description}</p>
                          </div>}
                          <p className="mb-0">
                            <span style={{ fontWeight: "bold" }}>Price</span>: $
                            {plan?.price}
                          </p>
                          {/* <p>Plan Id: {plan?.stripe_plan_id}</p> */}
                          {/* {plan?.plan_type !== "budget" && ( */}


                          <p className="mb-0" style={{ fontWeight: "bold" }}>
                            Max budget: {plan?.max_projects}
                          </p>


                          {findDates(plan)?.startDate && (
                            <p className="mb-0">
                              <span style={{ fontWeight: "bold" }}>
                                Start Date
                              </span>
                              : {findDates(plan)?.startDate}
                            </p>
                          )}
                          {findDates(plan)?.renewalDate && (
                            <p className="mb-0">
                              <span style={{ fontWeight: "bold" }}>
                                Renewal Date
                              </span>
                              : {findDates(plan)?.renewalDate}
                            </p>
                          )}
                          {findDates(plan)?.trialEndDate && (
                            <p className="mb-0">
                              <span style={{ fontWeight: "bold" }}>
                                Trial End Date
                              </span>
                              : {findDates(plan)?.trialEndDate}
                            </p>
                          )}
                          <p className="mb-0">
                            <span style={{ fontWeight: "bold" }}>
                              Interval
                            </span>
                            : {plan?.interval}
                          </p>
                          {/* {!currentlyActivePlans?.find(
                              (p) => p?.auto_renewal === plan?.auto_renewal
                            ) ? (
                              <>
                                
                                  <Button
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      choosePlan(plan);
                                    }}
                                  >
                                    Buy
                                  </Button>

 
                              </>
                            ) : (
                              <Button
                                className="card-absolute-btn"
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "red",
                                }}
                                onClick={handleShow}
                                disabled={isCancelling}
                              >
                                Cancel Budget
                              </Button>
                            )} */}

                          {/* {(() => {
                            const activePlan = currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            );
                            if (activePlan?.auto_renewal === false) {
                              return (
                                <p style={{ color: "orange", fontWeight: "bold" }}>
                                  Your budget is cancelled, but you can use the service until{" "}
                                  {activePlan?.current_period_end}
                                </p>
                              );
                            }

                            if (activePlan?.is_active === false) {
                              return (
                                <Button
                                  className="card-absolute-btn"
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                  }}
                                  onClick={handleShow}
                                  disabled={isCancelling}
                                >
                                  Cancel Budget
                                </Button>
                              );
                            }

                            if (!activePlan) {
                              return (
                                <Button
                                className="card-absolute-btn"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => choosePlan(plan)}
                                >
                                  Buy
                                </Button>
                              );
                            }

                            return (
                              <Button
                                className="card-absolute-btn"
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "red",
                                }}
                                onClick={handleShow}
                                disabled={isCancelling}
                              >
                                Cancel Subscription
                              </Button>
                            );
                          })()} */}

                          {(() => {
                            const activePlan = currentlyActivePlans?.find(
                              (p) => p?.plan?.id === plan?.id
                            );

                            const hasProjectPlan = currentlyActivePlans?.find(
                              (p) => p?.plan?.plan_type === "budget"
                            );

                            // 1. Show notice if auto_renewal is false
                            if (activePlan?.auto_renewal === false) {
                              return (
                                <p className={`${styles.btnSubscriptionPage}`} style={{ color: "orange", fontWeight: "bold", fontSize: '13px' }}>
                                  Your subscription is cancelled, but you can use the service until{" "}
                                  {activePlan?.current_period_end}
                                </p>
                              );
                            }

                            // 2. Show cancel button if is_active is false
                            if (activePlan?.is_active === false) {
                              return (
                                <Button
className={`${styles.btnSubscriptionPage}`}                
                  style={{
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                  }}
                                  onClick={() => handleShow('budgets', plan?.id)}
                                  disabled={isCancelling}
                                >
                                  Cancel Subscription
                                </Button>
                              );
                            }

                            // 3. No active budget plan — handle Buy / Upgrade / Unavailable
                            if (!activePlan) {
                              if (plan?.can_add_subscription === false) {
                                return <MaxUsersNotice />;
                              }

                              return !hasProjectPlan ? (
                                <Button
                                  className={`${styles.btnSubscriptionPage}`}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => choosePlan(plan)}
                                >
                                  Buy
                                </Button>
                              ) : (
                                <Button
className={`${styles.btnSubscriptionPage}`}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    if (enabledBuy(plan)) choosePlan(plan);
                                  }}
                                  disabled={!enabledBuy(plan)}
                                >
                                  {enabledBuy(plan) ? "Upgrade" : "Unavailable"}
                                </Button>
                              );
                            }

                            // 4. Default case: user has an active budget plan
                            return (
                              <Button
className={`${styles.btnSubscriptionPage}`}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "red",
                                }}
                                onClick={() => handleShow('budgets', plan?.id)}
                                disabled={isCancelling}
                              >
                                Cancel Subscription
                              </Button>
                            );
                          })()}


                        </div>
                      </Card>
                    </Col>
                  ))}

              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
